import { BaseThemeService } from '@adaptiva/core/themes';
import { AuthenticationService, SystemConfigService } from '@adaptiva/data-service';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

@Component({
	standalone: false,
	selector: 'ada-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {

	protected readonly auth: AuthenticationService = inject(AuthenticationService);
	
	protected readonly systemConfig: SystemConfigService = inject(SystemConfigService);
	
	protected readonly themes: BaseThemeService = inject(BaseThemeService);

}
